/** One discoverable kit registry and template lookup for rendering and authoring. */
import { HIDEOUT_PIECES } from '../hushHideout';
import { YARD_PIECES } from './kits/yard';
import { MILLRACE_PIECES } from './kits/millrace';
import { LOOT_PIECES } from './kits/loot';
import { COURSE_PIECES } from './kits/course';
import type { PieceDefinition } from './contract';

export const PIECE_KITS = { hush: HIDEOUT_PIECES, yard: YARD_PIECES, millrace: MILLRACE_PIECES, loot: LOOT_PIECES, course: COURSE_PIECES } as const;
export type PieceKit = keyof typeof PIECE_KITS;

export function assertUniquePieceIds(kits: Readonly<Record<string, Readonly<Record<string, PieceDefinition>>>>): void {
  const ids = new Set<string>();
  for (const [kit, pieces] of Object.entries(kits)) for (const id of Object.keys(pieces)) {
    if (ids.has(id)) throw new Error(`Duplicate piece ${id} in kit ${kit}`);
    ids.add(id);
  }
}
assertUniquePieceIds(PIECE_KITS);
export const PIECES = { ...PIECE_KITS.hush, ...PIECE_KITS.yard, ...PIECE_KITS.millrace, ...PIECE_KITS.loot, ...PIECE_KITS.course } as const;
export type PieceTemplate = keyof typeof PIECES;
export function isPieceTemplate(t: unknown): t is PieceTemplate {
  return typeof t === 'string' && Object.prototype.hasOwnProperty.call(PIECES, t);
}
export function isLegacyPiece(t: string): boolean {
  return Object.prototype.hasOwnProperty.call(HIDEOUT_PIECES, t) || Object.prototype.hasOwnProperty.call(YARD_PIECES, t);
}
export type { PieceArt, PieceRecipe, PieceDefinition, Point, PaletteRole, ResolvedPalette } from './contract';
